<template>
  <div v-show="showContent" class="clicktobuy">
    <p>{{msgWord}} <span> {{ count }} {{ msgText }}</span> à sua configuração, na loja online Hyundai Click to Buy.</p>
    <a :href="url" class="btn-secondary-inverted" target="_blank">Comprar na Click to Buy</a>
  </div>
</template>
<script>
import axios from 'axios';
import { mapGetters, mapState } from 'vuex';

export default {
  created(){
    axios.get(`${process.env.VUE_APP_API_CLICK_TO_BUY}${this.resumeData.versionID}/count`, {
      headers: { companyId: 1 },
      params: this.getDS_ClickToBuyParams
    })
    .then(res => {
      let data = res.data.data
      let item = data.find(el => el.count != 0)
      const totalCars = item.count;

      if(item){
        this.msgWord = totalCars == 1 ? 'Existe' : 'Existem'
        this.msgText =
          item.criteria == 1
            ? totalCars == 1 ? 'carro que corresponde exatamente'
            : 'carros que correspondem exatamente'
          : totalCars == 1
            ? 'carro que corresponde parcialmente'
            : 'carros que correspondem parcialmente';

        this.count = totalCars
        this.url = item.url
      }else{
        this.showContent = false
      }
    })
    .catch(() => this.showContent = false)
  },
  data(){return {
    count: '',
    url: '',
    showContent: true,
    msgWord: '',
    msgText: '',
  }},
  computed: {
    ...mapState(['resumeData']),
    ...mapGetters({
      getDS_ClickToBuyParams: 'resumeData/getDS_ClickToBuyParams',
    })
}
}
</script>
<style lang='scss' scoped>
@import './ClickToBuy.scss';
</style>
